import {
  getDictCodes
} from '@/api/system/dict';
import {
  getPartnerList,
  getSuppliers,
  submitPartnerInfo,
  deletePartners
} from '@/api/runActivityManage/partner';
import {
  getGiftTypeList,
  getGiftList,
  submitGiftTypeInfo,
  deleteGiftType,
  getGiftTypeOptions,
  submitGiftInfo,
  deleteGifts,
  exportGifts,
  importGifts,
  exportGiftsTemplate,
  decode,
  getGiftRecords,
  getActivityOptions
} from '@/api/runActivityManage/gift';
import {
  getActivityList,
  getProductList,
  getSMSTemplates,
  getChannels,
  submitActivityForm,
  handupApprove,
  submitApprove,
  deleteActivities,
  getApproveLogs
} from '@/api/runActivityManage/activity';
import {
  getMemberTypeLocalDict
} from '@/api/memberNew/memberType';
const state = {
  cacheExpire: Date.now(),
  partnerList: [],
  giftTypeList: [],
  giftList: [],
  activityList: [],
  total: 0,
  dicts: {
    'GIFT_STATUS': null,
    'YES_NOT': null,
    'DING_TALK_CHAT': null,
    'PLATFORM_TYPES': null,
    'PROMOTION_TYPES': null,
    'DEVICE_TYPES': null,
    'GIFT_RECEIVE_TYPES': null,
    'GIFT_CATEGORY': null,
    'GIVE_GIFT_CONDITION': null,
    'ACTIVITY_STATUS': null,
    'APPROVE_STATUS': null
  },
  giftRecords: [],
  activityOptions: [],
  giftTypeOptions: [],
  productList: [],
  channelList: [],
  smsTemplateList: [],
  logs: [],
  activiedTab: '1',
  suppliers: [], // 赠品提供方
  memberTypes: [], // 会员类型
};

// function isExpired(expire) {
//   const duration = 5 * 60 * 60 * 1000; // 缓存5小时
//   const now = Date.now();
//   return (now > expire + duration);
// }

const mutations = {
  CLEAR_DICTS: (state) => {
    for (let key of Object.keys(state.dicts)) {
      state.dicts[key] = null;
    }
  },
  CHANGE_TAB: (state, tabId) => {
    state.activiedTab = tabId;
  },
  UPDATE_PARTNERS: (state, list) => {
    state.partnerList = list;
  },
  UPDATE_TOTAL: (state, total) => {
    state.total = total;
  },
  UPDATE_DICTS: (state, [dicts, code]) => {
    state.dicts[code] = dicts;
  },
  UPDATE_SUPPLIERS: (state, list) => {
    state.suppliers = list;
  },
  UPDATE_MEMBER_TYPES: (state, list) => {
    state.memberTypes = list;
  },
  UPDATE_GIFT_TYPES: (state, list) => {
    state.giftTypeList = list;
  },
  UPDATE_GIFT_TYPE_OPTIONS: (state, list) => {
    state.giftTypeOptions = list;
  },
  UPDATE_GIFTS: (state, list) => {
    state.giftList = list;
  },
  UPDATE_GIFT_RECORDS: (state, list) => {
    state.giftRecords = list;
  },
  UPDATE_ACTIVITIES: (state, list) => {
    state.activityList = list;
  },
  UPDATE_PRODUCTS: (state, list) => {
    state.productList = list;
  },
  UPDATE_SMS_TEMPLATE: (state, list) => {
    state.smsTemplateList = list;
  },
  UPDATE_CHANNELS: (state, list) => {
    list.forEach(item => (item.checked = item.checked || false));
    state.channelList = list;
  },
  DEFAULT_SELECTION: (state, ids) => {
    state.channelList = state.channelList.map(item => {
      item.checked = ids.indexOf(item.id) !== -1;
      return item;
    })
  },
  UPDATE_ACTIVITY_OPTIONS: (state, options) => {
    state.activityOptions = options;
  },
  SELECT_ALL_CHANNEL_CHANGE: (state, isAll) => {
    state.channelList.forEach(item => (item.checked = isAll));
  },
  SELECT_ONE_CHANNEL_CHANGE: (state, {
    row,
    isChecked
  }) => {
    for (let item of state.channelList) {
      if (item.id === row.id) {
        item.checked = isChecked;
        break;
      }
    }
  },
  UPDATE_LOGS: (state, list) => {
    state.logs = list;
  }
};

const actions = {
  // 非加密 code 卷码
  decode(_content, id) {
    return decode(id).then(response => {
      const res = response.data;
      if (res.code === 200) {
        return res.data;
      }
      return res;
    })
  },
  // 查询赠品记录
  getGiftRecords({
    commit
  }, query) {
    getGiftRecords(query).then(({
      data: res
    }) => {
      if (res.code === 200) {
        const data = res.data || {};
        commit('UPDATE_GIFT_RECORDS', data.records || []);
        commit('UPDATE_TOTAL', data.total);
      }
    })
  },
  // 获取活动下拉
  getActivityOptions({
    commit
  }) {
    getActivityOptions().then(response => {
      const res = response.data;
      if (res.code === 200) {
        commit('UPDATE_ACTIVITY_OPTIONS', res.data);
      }
    })
  },
  // 选择渠道操作
  selectAllChange({
    commit
  }, isAll) {
    commit('SELECT_ALL_CHANNEL_CHANGE', isAll);
  },
  selectOneChange({
    commit
  }, payload) {
    commit('SELECT_ONE_CHANNEL_CHANGE', payload);
  },
  // 编辑活动渠道显示
  defaultSelection({
    commit
  }, ids) {
    commit('DEFAULT_SELECTION', ids);
  },
  clearDicts({
    commit
  }) {
    commit('CLEAR_DICTS')
  },
  changeTab({
    commit
  }, tabId) {
    commit('CHANGE_TAB', tabId);
  },
  submitPartnerForm(_context, payload) {
    return submitPartnerInfo(payload).then(response => {
      const res = response.data;
      if (res.code === 200) {
        return true;
      }
    })
  },
  delPartners(_context, data) {
    return deletePartners(data).then(response => {
      const res = response.data;
      if (res.code === 200) {
        return true;
      }
    })
  },
  getPartnerList({
    commit
  }, payload) {
    return getPartnerList(payload).then(response => {
      const res = response.data;
      if (res.code === 200) {
        const data = res.data || {};
        commit('UPDATE_PARTNERS', data.records || []);
        commit('UPDATE_TOTAL', data.total);
      }
    })
  },
  // 获取赠品提供方列表
  getSuppliers({
    commit
  }) {
    return getSuppliers().then(response => {
      const res = response.data;
      if (res.code === 200) {
        commit('UPDATE_SUPPLIERS', res.data || []);
      }
    })
  },
  // 获取会员类型
  getMemberTypes({
    commit
  }) {
    return getMemberTypeLocalDict().then(({
      data
    }) => {
      commit('UPDATE_MEMBER_TYPES', data.data || [])
    }).catch(() => {});
  },
  // 编辑赠品类型数据
  submitGiftTypeForm(_context, payload) {
    return submitGiftTypeInfo(payload).then(response => {
      const res = response.data;
      if (res.code === 200) {
        return true;
      }
    })
  },
  // 删除赠品类型
  delGiftTypes(_context, data) {
    return deleteGiftType(data).then(response => {
      const res = response.data;
      if (res.code === 200) {
        return true;
      }
    })
  },
  handleExportGifts(_context, query) {
    return exportGifts(query).then(response => {
      const res = response.data;
      if (res.code === 200) {
        return true;
      }
    })
  },
  handleExportGiftsTemplate(_context) {
    return exportGiftsTemplate().then(response => {
      const res = response.data;
      if (res.code === 200) {
        return true;
      }
    })
  },
  handleImportGifts(_context, query) {
    return importGifts(query).then(response => {
      const res = response.data;
      if (res.code === 200) {
        return true;
      }
    })
  },
  // 获取赠品类型下拉数据
  getGiftTypeOptions({
    commit
  }) {
    return getGiftTypeOptions().then(response => {
      const res = response.data;
      if (res.code === 200) {
        commit('UPDATE_GIFT_TYPE_OPTIONS', res.data || []);
      }
    })
  },
  // 赠品类型列表
  getGiftTypeList({
    commit
  }, query) {
    return getGiftTypeList(query).then(response => {
      const res = response.data;
      if (res.code === 200) {
        const data = res.data || {};
        commit('UPDATE_GIFT_TYPES', data.records || []);
        commit('UPDATE_TOTAL', data.total);
      }
    })
  },
  // 赠品列表
  getGiftList({
    commit
  }, query) {
    return getGiftList(query).then(response => {
      const res = response.data;
      if (res.code === 200) {
        const data = res.data || {};
        const list = data.records.map(item => ({
          ...item,
          signed: false
        }))
        commit('UPDATE_GIFTS', list);
        commit('UPDATE_TOTAL', data.total);
      }
    })
  },
  submitGiftForm(_context, payload) {
    return submitGiftInfo(payload).then(response => {
      const res = response.data;
      if (res.code === 200) {
        return true;
      }
    })
  },
  delGifts(_context, data) {
    return deleteGifts(data).then(response => {
      const res = response.data;
      if (res.code === 200) {
        return true;
      }
    })
  },
  getDicts({
    commit
  }, code) {
    // if is exist will resolve soon
    getDictCodes(code).then(response => {
      const res = response.data;
      if (res.code === 200) {
        commit('UPDATE_DICTS', [res.data, code]);
      }
    })
  },
  // 获取赠品活动分页数据
  getActivities({
    commit
  }, query) {
    return getActivityList(query).then(response => {
      const res = response.data;
      if (res.code === 200) {
        const data = res.data || {};
        commit('UPDATE_ACTIVITIES', data.records || []);
        commit('UPDATE_TOTAL', data.total);
      }
    })
  },
  // 获取赠品类型下拉数据
  getProductOptions({
    commit
  }, type = '0') {
    return getProductList(type).then(response => {
      console.log('getProductOptions', response);
      const res = response.data;
      if (res.code === 200) {
        commit('UPDATE_PRODUCTS', res.data || []);
      }
    })
  },
  // 获取赠品类型下拉数据
  getSmsTemplateList({
    commit
  }) {
    return getSMSTemplates().then(response => {
      const res = response.data;
      if (res.code === 200) {
        commit('UPDATE_SMS_TEMPLATE', res.data || []);
      }
    })
  },
  // 获取赠品类型下拉数据
  getChannelList({
    commit
  }, query) {
    return getChannels(query).then(response => {
      const res = response.data;
      if (res.code === 200) {
        commit('UPDATE_CHANNELS', res.data || []);
      }
    })
  },
  // 获取日志
  getActivityLogs({
    commit
  }, payload) {
    return getApproveLogs(payload).then(response => {
      const res = response.data;
      if (res.code === 200) {
        commit('UPDATE_LOGS', res.data || []);
      }
    })
  },
  // 删除活动
  removeActivitys(_context, payload) {
    return deleteActivities(payload).then(response => {
      const res = response.data;
      if (res.code === 200) {
        return true;
      }
    })
  },
  // 保存活动数据
  submitActivityForm(_context, payload) {
    return submitActivityForm(payload).then(response => {
      console.log(response);
      const res = response.data;
      if (res.code === 200) {
        return true;
      }
    })
  },
  // 提交审核
  handupApprove(_context, payload) {
    return handupApprove(payload).then(response => {
      const res = response.data;
      if (res.code === 200) {
        return true;
      }
    })
  },
  // 处理审核
  handleApporveFlow(_context, payload) {
    return submitApprove(payload).then(response => {
      const res = response.data;
      if (res.code === 200) {
        return true;
      }
    })
  }
};

const getters = {
  receiveTypes: state => {
    return state.dicts['GIFT_RECEIVE_TYPES'] || [];
  },
  giftsTypes: state => {
    return state.dicts['GIFT_TYPE'] || []
  },
  giftTypes: state => {
    return state.dicts['GIFT_CATEGORY'] || [];
  },
  giftTypeOptions: state => state.giftTypeOptions,
  staticGiftTypeOptions: state => state.giftTypeOptions.filter(item => item.giftMode == 1),
  gifts: state => (state.giftList),
  giftStatus: state => {
    return state.dicts['GIFT_STATUS'] || [];
  },
  SMSStatus: state => {
    return state.dicts['YES_NOT'] || [];
  },
  dingTalkOptions: state => {
    return state.dicts['DING_TALK_CHAT'] || [];
  },
  platformTypes: state => {
    return state.dicts['PLATFORM_TYPES'] || [];
  },
  deviceTypes: state => {
    return state.dicts['DEVICE_TYPES'] || [];
  },
  giveConditions: state => {
    return state.dicts['GIVE_GIFT_CONDITION'] || [];
  },
  promotionTypes: state => {
    return state.dicts['PROMOTION_TYPES'] || []
  },
  activityStatus: state => {
    return state.dicts['ACTIVITY_STATUS'] || [];
  },
  approveStatus: state => {
    return state.dicts['APPROVE_STATUS'] || [];
  }
};

export default {
  state,
  mutations,
  actions,
  getters,
  namespaced: true
};
